// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Outlet, useSearchParams, useNavigate } from 'react-router-dom';
import { ROUTES, SEARCH_PARAMS } from '../../const';
import { useBrowserDetect } from '../../hooks';

const PageContent = styled.div``;

export function HomePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { isSafari } = useBrowserDetect();

  useEffect(() => {
    // Only route on first load

    if (isSafari()) {
      navigate(ROUTES.step1);
    } else {
      navigate(ROUTES.notSupported);
    }
  }, []);

  useEffect(() => {
    // Set page based on query param
    const page = searchParams.get(SEARCH_PARAMS.page);
    const pageNum = parseInt(page ?? '');
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum < Object.keys(ROUTES).length) {
      const keyName = `step${pageNum}`;
      navigate((ROUTES as { [key: string]: string })[keyName]);
    }
  }, [searchParams]);

  return (
    <PageContent>
      <Outlet />
    </PageContent>
  );
}
